export default "__VITE_ASSET__rsCCthEg__"